enum GiftCardsErrors {
    GIFTCARD_STRATEGY_NOT_FOUND = "GIFTCARD_STRATEGY_NOT_FOUND",
    LOCAL_GIFTCARD_INVALID_TYPE = "LOCAL_GIFTCARD_INVALID_TYPE",
    LOCAL_GIFTCARD_NOT_FOUND = "LOCAL_GIFTCARD_NOT_FOUND",
}

export default GiftCardsErrors;
